import React from "react";
export type SocialNetwork = "instagram" | "facebook" | "x" | "linkedin";
type SocialIconProps = {
  network: SocialNetwork;
  size?: number;
  className?: string;
};

// Brand marks drawn inline so they inherit `currentColor` and stay crisp at any size.
export function SocialIcon({
  network,
  size = 18,
  className = ""
}: SocialIconProps) {
  const common = {
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    className,
    "aria-hidden": true,
    focusable: false
  } as const;
  if (network === "instagram") {
    return <svg {...common} fill="none" stroke="currentColor" strokeWidth={1.9} data-id="element-437" data-mp="2qvfsy2krkmm2">
        <rect x="3" y="3" width="18" height="18" rx="5" data-id="element-438" data-mp="34uf88jmdzp5k" />
        <circle cx="12" cy="12" r="4.2" data-id="element-439" data-mp="34rt1unb8ffox" />
        <circle cx="17.4" cy="6.6" r="1.1" fill="currentColor" stroke="none" data-id="element-440" data-mp="30s2cmo1ct7mi" />
      </svg>;
  }
  if (network === "facebook") {
    return <svg {...common} fill="currentColor" data-id="element-441" data-mp="k1vaijibiqlk">
        <path d="M24 12.07C24 5.41 18.63 0 12 0S0 5.4 0 12.07C0 18.1 4.39 23.1 10.13 24v-8.44H7.08v-3.49h3.04V9.41c0-3.02 1.8-4.7 4.54-4.7 1.31 0 2.68.24 2.68.24v2.97h-1.5c-1.5 0-1.96.93-1.96 1.89v2.26h3.33l-.53 3.5h-2.8V24C19.62 23.1 24 18.1 24 12.07" data-id="element-442" data-mp="g2mfzcfgeooy" />
      </svg>;
  }
  if (network === "x") {
    return <svg {...common} fill="currentColor" data-id="element-443" data-mp="32rc7svmz0dla">
        <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z" data-id="element-444" data-mp="32o6fl7j1ovlc" />
      </svg>;
  }
  return <svg {...common} fill="currentColor" data-id="element-445" data-mp="2axa68gw7192t">
      <path d="M20.45 20.45h-3.55v-5.57c0-1.33-.02-3.04-1.85-3.04-1.85 0-2.14 1.45-2.14 2.94v5.67H9.35V9h3.41v1.56h.05c.48-.9 1.64-1.85 3.37-1.85 3.6 0 4.27 2.37 4.27 5.46v6.28zM5.34 7.43a2.06 2.06 0 1 1 0-4.12 2.06 2.06 0 0 1 0 4.12zM7.12 20.45H3.56V9h3.56v11.45z" data-id="element-446" data-mp="2ezwy2hsv6u00" />
    </svg>;
}